/**
 * Traduce errores de axios a mensajes claros para el usuario.
 * El backend responde { error, code, field? }; si la respuesta no es JSON
 * (proxy, bloqueo de red, caída del servidor) se muestra un mensaje según el caso.
 */
export interface ErrorApi {
  message: string;
  code?: string;
  field?: string;
}

export function leerError(err: any, fallback: string): ErrorApi {
  const res = err?.response;
  if (!res) {
    return { message: 'No pudimos conectar con el servidor. Revisa tu conexión a internet e intenta de nuevo.', code: 'SIN_CONEXION' };
  }
  const data = res.data;
  if (data && typeof data === 'object' && typeof data.error === 'string') {
    return { message: data.error, code: data.code, field: data.field };
  }
  if (res.status === 429) return { message: 'Demasiados intentos. Espera un minuto y vuelve a intentarlo.', code: 'RATE_LIMIT' };
  if (res.status >= 500) return { message: 'El servicio no está disponible en este momento. Intenta de nuevo en unos minutos.', code: 'ERROR_SERVIDOR' };
  if (res.status === 403 && typeof data === 'string') {
    return { message: 'Tu red bloqueó la conexión con tRespondo (firewall o filtro de contenido). Prueba desde otra red o pide a TI que habilite trespondo.cl.', code: 'BLOQUEO_RED' };
  }
  return { message: fallback };
}
